import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=e9b7b678&scoped=true"
import script from "./ResetForm.vue?vue&type=script&lang=js"
export * from "./ResetForm.vue?vue&type=script&lang=js"
import style0 from "./ResetForm.vue?vue&type=style&index=0&id=e9b7b678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b7b678",
  null
  
)

export default component.exports